module.exports = __webpack_public_path__ + "img/sign-activity-tag.16fb5d44.png";